export default "https://assets.egbcdn.net/assets/packs/_/images/chat/chat-hero-04020a7ce746141765f1781cdb4b8e90.png";